













































































































































































































import Vue, { PropType } from 'vue'
import { Project } from '@/model/Project'
import { Multimedia } from '@/model/Multimedia'
import { Category } from '@/model/Category'
import { Tag } from '@/model/Tag'
import ProjectDescriptionEditor from '@/components/project/ProjectDescriptionEditor.vue'
import ProjectDetails from '@/components/project/ProjectDetails.vue'
import ProjectFormMultimedia from '@/components/project/ProjectFormMultimedia.vue'
import AddImageDialog from '@/components/project/AddImageDialog.vue'
import AddMovieDialog from '@/components/project/AddMovieDialog.vue'
import PagedResults from '@/service/PagedResults'

export default Vue.extend({
  name: 'ProjectForm',

  components: {
    ProjectDescriptionEditor,
    ProjectDetails,
    ProjectFormMultimedia,
    AddImageDialog,
    AddMovieDialog,
  },

  props: {
    value: {
      type: Object as PropType<Project>,
    },
    publishLoading: {
      type: Boolean,
    },
  },

  mounted() {
    const apiPromises = []
    const allCategories = new PagedResults<Category[]>(this.$api)
    const allTags = new PagedResults<Tag[]>(this.$api)

    apiPromises.push(
      allCategories
        .all('/categories', 30)
        .then((response) => (this.categories = response))
        .catch(() =>
          this.$store.dispatch(
            'alert/error',
            'Problems with reading project categories.'
          )
        )
    )

    apiPromises.push(
      allTags
        .all('/project_tags', 30)
        .then((response) => (this.tags = response))
    )

    Promise.allSettled(apiPromises)
      .catch(() =>
        this.$store.dispatch(
          'alert/error',
          'Problem with reading API for project.'
        )
      )
      .finally(() => {
        this.value.categories && this.value.categories[0] && (
          this.selectedCategory = this.value.categories[0] as Category
        )

        this.updateTags()
      })
  },

  data: () => ({
    startDateDialog: false,
    addImageDialog: false,
    addMovieDialog: false,
    selectedCategory: {} as Category,
    categories: [] as Category[],
    tags: [] as Tag[],
    selectedTags: [] as string[],
    step: 1,
    step1Valid: false,
    nameRules: [(v: string) => !!v || "Name value can't be empty."],
    categoryRules: [(v: Category) => !!v.name || "Category must be select from the list."],
    startAtRules: [(v: string) => !!v || "Project start date can't be empty."],
    onlyEnglishAlert: 'Please remember to use english only',
    descriptionCharactersCount: 0,
    abstractDescriptionCharactersCount: 0
  }),

  methods: {
    gotoStep2: function () {
      if (!(this.$refs.step1Form as any).validate()) {
        this.$store.dispatch(
          'alert/error',
          'There are some errors in the form.'
        )

        return
      }

      if (this.value.multimedia.length === 0) {
        this.$store.dispatch(
          'alert/error',
          'Add at least one image to the project.'
        )

        return
      }

      if (!this.value.mainImage) {
        this.$store.dispatch(
          'alert/error',
          'One image have to be set as cover image.'
        )

        return
      }

      this.value.categories ? this.value.categories[0] = this.selectedCategory : this.value.categories = [this.selectedCategory]

      const newTags = [] as Tag[]

      for (let i = 0; i < this.selectedTags.length; i++) {
        newTags.push({ name: this.selectedTags[i] })
      }

      this.value.tags = newTags

      this.step = 2
    },

    gotoStep3: function () {
      if (!this.value.abstractDescription) {
        this.$store.dispatch(
          'alert/error',
          'Abstract description for the project is required.'
        )

        return
      }

      if (this.abstractDescriptionCharactersCount >= 1500) {
        this.$store.dispatch(
          'alert/error',
          'Abstract description can be maximum 1500 long.'
        )

        return
      }

      if (this.descriptionCharactersCount < 1000) {
        this.$store.dispatch(
          'alert/error',
          'Detailed informations for the project are required and should be at least 1000 characters long.'
        )

        return
      }

      (this.$refs.projectDetailsRef as any).fetchProject()
      this.step = 3
    },

    updateTags: function () {
      this.selectedTags = []

      for (let i = 0; i < this.value.tags.length; i++) {
        this.selectedTags.push(this.value.tags[i].name)
      }
    },

    deleteMedia: function (media: Multimedia) {
      if (media['@id'] === (this.value.mainImage as Multimedia)['@id']) {
        this.$store.dispatch(
          'alert/warning',
          'You must select new cover image first.'
        )

        return
      }

      const projectMultimedia = this.value.multimedia as Multimedia[]
      projectMultimedia.splice(projectMultimedia.indexOf(media), 1)
    },

    changeCoverImage: function (media: Multimedia) {
      this.value.mainImage = media
    },

    addUploadedImages: function (multimedia: Multimedia[]) {
      const projectMultimedia = this.value.multimedia as Multimedia[]
      this.value.multimedia = [...projectMultimedia, ...multimedia]

      if (!this.value.mainImage) {
        this.changeCoverImage(multimedia[0])
      }
    },

    addYoutubeMovie: function (multimedia: Multimedia) {
      (this.value.multimedia as Multimedia[]).push(multimedia)
    },
  },

  watch: {
    'value.tags': function () {
      this.updateTags()
    },
  },
})
